<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />

<div class="px-(--space-4)">
  <ces-route-title [count]="campaignModels().length">
    @if (currentAssetId(); as assetId) {
      <ces-button
        [hasPermission]="{ method: 'postCampaignModelListResource', assetId }"
        [label]="'entities.campaign.models.createTitle' | transloco"
        icon="add"
        (onClick)="onCreateModel()" />
    }
  </ces-route-title>

  <div class="mt-(--space-4)">
    <ces-generic-parent-grid
      [entityDefinition]="tableDefinition()"
      [entities]="campaignModels()"
      [dataLoadingCompleted]="!isLoading()"
      [selectionMode]="false"
      (customAction)="onRowAction($event.action, $event.entity, $event.event)" />
  </div>
</div>

<ces-popup-menu #actionMenu [items]="menuItems()" />
